import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { SoftTissueAutoPoppulateModel } from '../pin-detail-models/soft-tissue-auto-populate-model';
import { SoilAutoPoppulateModel } from '../pin-detail-models/soil-auto-populate-model';

@Injectable({
  providedIn: 'root',
})
export class PinDetailsService {

  private softTissuePinSampleSubject = new BehaviorSubject<SoftTissueAutoPoppulateModel | null>(null);
  private soilPinSampleSubject = new BehaviorSubject<SoilAutoPoppulateModel | null>(null);


  // Set soft tissue pin sample
    setSoftTissueSampleDetails(softTissueSampleDetail: SoftTissueAutoPoppulateModel | null){
    this.softTissuePinSampleSubject.next(softTissueSampleDetail);
    }

    // Set soil pin sample
    setSoilSampleDetails(soilSampleDetail: SoilAutoPoppulateModel | null){
    this.soilPinSampleSubject.next(soilSampleDetail);
    }

  //get soft tissue pin sample
  getSoftTissueSampleDetails(): SoftTissueAutoPoppulateModel | null{
    return this.softTissuePinSampleSubject?.value;
  }

    //get soil pin sample
  getSoilSampleDetails(): SoilAutoPoppulateModel | null{
    return this.soilPinSampleSubject?.value;
  }
  //clear soft tissue pin sample
  clearSampleDetails(){
    this.softTissuePinSampleSubject.next(null);
    this.soilPinSampleSubject.next(null);
}}
